import apiClient from '../apiClient';
import { DELETE_TOUR_OPERATOR_MARGIN_URL } from '../apiUrl';

const deleteTourOperatorMarginApi = Id => {
  return apiClient.delete(DELETE_TOUR_OPERATOR_MARGIN_URL(Id));
};

export default deleteTourOperatorMarginApi;
